export default __webpack_public_path__ + "static/media/mongo-db.3231675c.png";